import React from 'react';
import { makeStyles } from '@material-ui/core';
import Fetcher from './Fetcher';
import AnnouncmentItem from './AnnouncmentItem';
import useAnnouncementData from './useAnnouncementData';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 25,
    marginTop: '-16px',

    '&:empty': {
      display: 'none',
    },
  },
}));

const AnnouncementDisplayBar = () => {
  const classes = useStyles();
  const data = useAnnouncementData();
  const { pathname } = useLocation();

  if (pathname === '/announcements') {
    return <></>;
  }

  return (
    <>
      <Fetcher />

      {data.length ? (
        <div className={classes.root}>
          {data.map((item) => (
            <AnnouncmentItem key={item._id} details={item} />
          ))}
        </div>
      ) : null}
    </>
  );
};

export default AnnouncementDisplayBar;
